import React, { useEffect, useState } from 'react'

type Page = { html: string; meta?: Record<string, string> }

export default function MarkdownPage({ name }: { name: string }){
  const [page, setPage] = useState<Page | null>(null)
  const [err, setErr] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try{
        const res = await fetch(`/api/content/${name}`)
        if(!res.ok){
          const j = await res.json().catch(()=>({html: '<div class="card"><h3>Not found</h3></div>'}))
          if(!cancelled){ setPage(j); }
          return
        }
        const j = await res.json()
        if(!cancelled){ setPage(j) }
      }catch(e:any){
        if(!cancelled){ setErr(e?.message ?? 'Failed to load') }
      }
    })()
    return () => { cancelled = true }
  }, [name])

  if(err){ return <div className="card">{err}</div> }
  if(!page){ return <div className="card">Loading…</div> }

  return (
    <article className="markdown" dangerouslySetInnerHTML={{ __html: page.html }} />
  )
}
